module.exports = __webpack_public_path__ + "public/img/v-cover.6c9c7241.png";